// extracted by mini-css-extract-plugin
export default {"tip":"_2Ijyy8Md","recaptcha":"_1c5Op3_E"};